const createLinkToLanding = (path: string) => `https://newcrom.com${path}`;

type Link = {
  title: string;
  url: string;
};

const shopHardwareKits: Link[] = [
  {
    title: 'Alltesta Basic',
    url: createLinkToLanding('/alltesta-isocratic/'),
  },
  {
    title: 'Alltesta Gradient',
    url: createLinkToLanding('/alltesta-gradient/'),
  },
  {
    title: 'Cromite',
    url: createLinkToLanding('/cromite/'),
  },
  {
    title: 'Samplify Automated Sampling',
    url: createLinkToLanding('/samplify/'),
  },
];

const shopHardware: Link[] = [
  {
    title: 'Syringe Pump',
    url: createLinkToLanding('/pump/'),
  },
  {
    title: 'Autosampler',
    url: createLinkToLanding('/autosampler/'),
  },
  {
    title: 'Valve',
    url: 'https://sielc.com/product/alltesta-high-pressure-switching-valve',
  },
  {
    title: 'UV Vis Detector',
    url: createLinkToLanding('/detector/'),
  },
];

const hplcCloud: Link[] = [
  {
    title: 'Manage account',
    url: 'https://hplc.cloud/app/account/',
  },
  {
    title: 'Get support',
    url: '/contacts/',
  },
];

const forBussines: Link[] = [
  {
    title: 'Newcrom and business',
    url: createLinkToLanding('/'),
  },
  {
    title: 'Shop for business',
    url: createLinkToLanding('/'),
  },
];

const forEducation: Link[] = [
  {
    title: 'Newcrom and education',
    url: createLinkToLanding('/'),
  },
  {
    title: 'Shop for education',
    url: createLinkToLanding('/'),
  },
];

const aboutNewcrom: Link[] = [
  {
    title: 'Newsroom',
    url: createLinkToLanding('/'),
  },
  {
    title: 'Contact Newcrom',
    url: createLinkToLanding('/contacts'),
  },
  {
    title: 'Career Opportunities',
    url: createLinkToLanding('/contacts#carrer'),
  },
  {
    title: 'Newcrom Leadership',
    url: createLinkToLanding('/'),
  },
];

export default {
  shopHardwareKits,
  shopHardware,
  hplcCloud,
  forBussines,
  forEducation,
  aboutNewcrom,
};
